import { render, staticRenderFns } from "./packageInfo.vue?vue&type=template&id=198d37e8&scoped=true&"
import script from "./packageInfo.vue?vue&type=script&lang=js&"
export * from "./packageInfo.vue?vue&type=script&lang=js&"
import style0 from "./packageInfo.vue?vue&type=style&index=0&id=198d37e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198d37e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198d37e8')) {
      api.createRecord('198d37e8', component.options)
    } else {
      api.reload('198d37e8', component.options)
    }
    module.hot.accept("./packageInfo.vue?vue&type=template&id=198d37e8&scoped=true&", function () {
      api.rerender('198d37e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/OMS/components/Order/packageInfo.vue"
export default component.exports